import Vue from 'vue'
import { mapState } from 'vuex'
import rolebleMixin from '@/mixins/rolebleMixin'
import {
  disputableMixin,
  doneJobManageMixin,
  jobPartiesMixin,
  offerManageMixin,
  payableMixin,
  refundableMixin,
  reviewableMixin,
  startableMixin,
  statusesMixin,
} from '../mixins'

export default Vue.extend<any, any, any, any>({
  mixins: [
    disputableMixin,
    doneJobManageMixin,
    offerManageMixin,
    jobPartiesMixin,
    rolebleMixin,
    payableMixin,
    refundableMixin,
    reviewableMixin,
    startableMixin,
    statusesMixin,
  ],
  computed: {
    ...mapState({
      application: (state: any) => state.jobChat.application.value,
    }),
    hasBtns() {
      return (
        this.hasJobWasDone ||
        this.hasSendOffer ||
        this.hasJobDone ||
        this.hasCreateDispute ||
        this.hasStartJob ||
        this.hasPayJob ||
        this.hasRefund ||
        this.hasLeaveReview ||
        this.hasReviewed ||
        this.hasViewInvoice
      )
    },
  },
  methods: {
    onPayToTalentClick() {
      this.payToTalent()
    },
    onRefundClick() {
      this.refundToCustomer()
    },
    onStartJobClick() {
      this.startJob()
    },
    onCreateDisputeClick() {
      this.createDispute()
    },
    onLeaveReviewClick() {
      this.leaveReview()
    },
    onSendOfferClick() {
      this.sendOffer()
    },
    onDoneClick() {
      this.markJobAsDone()
    },
    onCancelJobDoneClick() {
      this.markJobAsNotDone()
    },
  },
})
